<template lang="pug">
section.card-item.col-12(v-if='profile')
  .title.d-flex.justify-content-between.align-items-center
    h5 Connect Bank
    button.btn.btn-primary(v-if='!loading', @click='connectBank()') Connect Bank
    button.btn.btn-primary(v-else, disabled) Loading
  p Connect your bank accounts using our secure platform powered by Plaid (https://plaid.com/)
  .empty.text-center(v-if='!profile.accounts || profile.accounts.length === 0')
    strong No banks here yet.
    br
    small Add your bank accounts to be processed
  div(v-else)
    .account(v-for='account in profile.accounts', :key='account.item_id')
      .d-flex.justify-content-between.align-items-center
        div {{ account.displayName || account.instRes.institution.name }}
        div(v-if='!currentAccount._id')
          button.btn.btn-primary(@click='currentAccount = account') Edit Name
        div(v-else-if='currentAccount._id === account._id')
          input(type='text', v-model='displayName')
          button.btn.btn-primary(@click='updateDisplayName(account._id)') Save
        div
          span Currently proccessing {{ account.processingAccounts ? account.processingAccounts.length : 0 }} accounts
        div
          button.btn.btn-primary(:disabled='loading', @click='select(account)') Select Accounts
          button.btn.btn-danger(:disabled='loading', @click='remove(account)') Remove
      div(v-if='currentAccount._id && currentAccount._id === account._id && bankAccounts.length > 0')
        strong Select Accounts for us to process
        b-form-checkbox-group(stacked v-model="selected", name="backAccounts", :options="bankAccounts")
        button.btn.btn-primary(:disabled='loading', @click='save()') Save
</template>

<style lang="scss" scoped>
  .title, p {
    margin-bottom: 1.5rem;
  }

  .card-item {
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.25);
    border-radius: 3px;
    border: none;
    padding: 18px 33px 20px 33px;
    margin-bottom: 1rem;
  }

  .empty {
    background: #efefef;
    margin: 0 auto;
    margin-top: 2rem;
    margin-bottom: 4rem;
    width: 300px;
    border-radius: 4px;
    padding: 1rem 2rem;
  }

  .account {
    background: #efefef;
    padding: 1.5rem 1rem;
    margin-bottom: .5rem;
    border-radius: 3px;
  }
</style>

<script>
import firebase from 'firebase'
import axios from 'axios'
import findIndex from 'lodash/findIndex'

import { getPlaidAccounts, updateAccountName, storeProcessingAccounts } from '../lib/api'
import plaid from '../mixins/plaid'

export default {
  props: ['profile'],
  mixins: [plaid],
  data () {
    return {
      loading: false,
      bankAccounts: [],
      selected: [],
      currentIndex: 0,
      currentAccount: {},
      displayName: ''
    }
  },
  methods: {
    remove (index) {
      if (!confirm('Are you sure you want to remove this?')) return
      this.firebaseRemoveAccount(index)
    },
    async select (account) {
      this.loading = true
      this.bankAccounts = []
      this.currentAccount = account

      const res = await getPlaidAccounts(account)

      this.bankAccounts = res.data.accounts.map(account => {
        return {
          value: account.account_id,
          text: `${account.name} - Account Number: ${account.mask}`
        }
      })

      this.selected = account.processingAccounts;

      this.loading = false
    },
    save () {
      if (!confirm('Are you sure you want to update your processing accounts? This will affect your next report')) return

      storeProcessingAccounts(this.currentAccount._id, this.selected)

      this.bankAccounts = []
      this.selected = []
      this.currentAccount = {}
      this.currentIndex = 0
    },
    updateDisplayName (itemId) {
      if (!this.displayName) return

      updateAccountName(this.currentAccount._id, this.displayName)
      const accounnt = this.profile.accounts.find(acc => acc._id === itemId)
      accounnt.displayName = this.displayName

      this.displayName = ''
      this.currentIndex = 0
      this.currentAccount = {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Plaid.vue